export default function LoadingSpinner({ message = 'Loading…' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 20px', gap: '12px' }}>
      <div style={{
        width: '28px', height: '28px', border: '3px solid #E5E7EB',
        borderTop: '3px solid #1B2A4A', borderRadius: '50%',
        animation: 'spin 0.7s linear infinite',
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <span style={{ fontSize: '13px', color: '#9CA3AF' }}>{message}</span>
    </div>
  );
}
